export default "__VITE_ASSET__DJd9sPQ2__"